import React, { FC } from 'react';
import GroupDetailsPage from './group-details';
import { Route, Routes } from 'react-router-dom';
import GroupListsMainPage from './group-list-main-page';

const GroupsIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<GroupListsMainPage />} />
      <Route path={`/:id`} element={<GroupDetailsPage />} />
    </Routes>
  );
};

export default GroupsIndex;
